// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
const businessName = getSecondLevelDomain(); // localStorage.getItem('businessName-smart');

function getSecondLevelDomain(): any {
  const host = window.location.hostname;
  const parts = host.split('.');
  if (parts.length > 1 && parts[1] === 'smart-app') {
    const tenant = parts[0];
    localStorage.setItem('businessName-smart', tenant);
    localStorage.setItem('businessNameCorrect-smart', 'true');
  } else {
    // eslint-disable-next-line no-console
    console.log('Error on tenant!');
  }
  return localStorage.getItem('businessName-smart');
}
// export const apiHost = 'http://localhost:8080/';
// export const apiHost = 'http://192.168.1.90:8080/';
// export const apiHost = `https://for.maybit.it/`;
export const apiHost = `https://innova.maybit.it/`;

function getYear(): number {
  const date = new Date();
  return date.getFullYear();
}

export const environment = {
  production: false,
  apiUrl: `${apiHost}api`,
  lastDataUpdateKey: 'lastDataUpdate',
  rangeKey: 'defaultRange',
  appVersion: '1.2.1',
  copyright: getYear() + ' Formabit by Maybit srls',
  database: {
    name: 'formabit-1',
    tables: [
      {
        autoId: true,
        name: 'my-settings',
        uniqueFields: ['myKey'],
        notUniqueFields: [],
      },
      {
        autoId: false,
        name: 'account',
        uniqueFields: ['login', 'email'],
        notUniqueFields: [],
      },
      {
        autoId: false,
        name: 'project',
        uniqueFields: [],
        notUniqueFields: [],
      },
      {
        autoId: false,
        name: 'projectComplete',
        uniqueFields: [],
        notUniqueFields: [],
      },
      {
        autoId: false,
        name: 'question',
        uniqueFields: [],
        notUniqueFields: ['projectId', 'parentId'],
      },
      {
        autoId: true,
        name: 'answer-instance-local',
        uniqueFields: [],
        notUniqueFields: ['projectId', 'userId'],
      },
      {
        autoId: true,
        name: 'answer-local',
        uniqueFields: [],
        notUniqueFields: ['questionId', 'genericRegisterId', 'answerInstanceId'],
      },
      {
        autoId: true,
        name: 'answer-instance-sign-local',
        uniqueFields: [],
        notUniqueFields: ['projectSignId', 'answerInstanceId'],
      },
      {
        autoId: true,
        name: 'attachment-local',
        uniqueFields: [],
        notUniqueFields: ['projectId', 'answerInstanceId', 'answerId', 'questionId'],
      },
      {
        autoId: true,
        name: 'check-list',
        uniqueFields: [],
        notUniqueFields: ['projectId'],
      },
    ],
  },
};

function getApiUrl() {
  throw new Error('Function not implemented.');
}
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
